import { ApolloError } from '@apollo/client/errors';
import { GraphQLError } from 'graphql/error';
import isArrayLike from 'lodash/isArrayLike';
import join from 'lodash/join';
import map from 'lodash/map';
import { z } from 'zod';

/* eslint-disable @typescript-eslint/no-explicit-any */
export function getMessageFromError(error: any): string {
    if (typeof error === 'string') {
        return error;
    } else if (isArrayLike(error)) {
        return join(map(error, getMessageFromError), '\n ');
    } else if (error instanceof ApolloError) {
        return `${error.name}: ${error.message}`;
    } else if (error instanceof GraphQLError) {
        return error.message;
    } else if (error instanceof Error) {
        return error.message;
    } else {
        const parsed = z
            .object({
                message: z.string(),
            })
            .safeParse(error);

        if (parsed.success) {
            return parsed.data.message;
        } else {
            return 'Unknown error';
        }
    }
}
